import { BfxTradeBlotterComponent } from "../bfx-blotter-trade/bfx-trade-blotter.component";

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  NgZone,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

import { d3 } from "../shared/d3/d3";

import svgPanZoom from "svg-pan-zoom";

import {
  DetailedOrderStatusRequestPromiseService,
  BfxBlotterAction,
  SystemConfigPromiseService,
  SysFeatures,
  ColumnDefinition,
  ProfilePromiseActionService,
  CustomFieldPromiseLookupService,
  CcyLookupService,
  CurrencyPairCalendarLookupService,
  TraderGroupPromiseLookupService,
  CubiqWorker,
  TableDefinition,
} from "shared/cubiq-services";
import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { ElementRef, ViewChild } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxOrderDetailsContextMenuService } from "./bfx-order-details-contextmenu.service";
import { BfxBlotterOrdersActionService } from "../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxBlotterActionEvent } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxDealDetailsService } from "../bfx-deal-details/services/bfx-deal-details.service";

import { TranslateService } from "@ngx-translate/core";

// Migration must be kept in sync with Table Definition model
export const EMBEDDED_COMPONENT_CONFIG_VER = "2017112101";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { PerfectScrollbarComponent } from "@bfx/ngx-perfect-scrollbar";

import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxConfigIDRefHelper } from "../../shared/helper-services/bfx-config-id-ref-helper";
import { TabView } from "@bfx/primeng/tabview";
import { COLUMN_LADDER_POSITION } from "shared/cubiq-services/model/OrdersTableDefinitionFactory.constants";
import {
  BMRiskUtils,
  RiskData,
  RiskAggregate,
} from "shared/cubiq-services/model/benchmarks/helpers/BMRiskUtils";
import { ProductRenderer } from "shared/cubiq-services/model/orders/ProductRenderer";
import { ProductIntentRenderer } from "shared/cubiq-services/model/orders/ProductIntentRenderer";
import { BMOrderAmountHelper } from "shared/cubiq-services/model/benchmarks/helpers/BMOrderAmountHelper";
import { ValueDateRenderer } from "shared/cubiq-services/model/orders/ValueDateRenderer";
import { ValueDateHelper } from "shared/cubiq-services/model/orders/ValueDateHelper";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";
import { BfxBaseBlotter } from "app/bfx-base-blotter/bfx-base-blotter";
import { AgGridAngular } from "@bfx/ag-grid-angular";
import { Subject, Subscription, asyncScheduler, throttleTime } from "rxjs";
import { BfxTradeDetailsContextMenuService } from "app/bfx-blotter-trade/services/bfx-trade-blotter-details-contextmenu.service";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import { BfxAllocationsBlotterComponent } from "app/bfx-order-details/bfx-allocations-blotter.component";
// import { caseInsensitiveComparator } from '../../admin/admin-base/admin-locale-comparator';

export const EMBEDDED_ALLOCATIONS_BLOTTER_CONFIG_PROPERTY = "embeddedAllocationBlotterConfig";
export const EMBEDDED_TRADE_BLOTTER_CONFIG_PROPERTY = "embeddedTradeBlotterConfig";
export const EMBEDDED_RISK_TRADE_BLOTTER_CONFIG_PROPERTY = "embeddedRiskTradeBlotterConfig";
export const EMBEDDED_COMPONENT_VERSION_PROPERTY = "version";

const LOCALE = new Intl.NumberFormat().resolvedOptions().locale;
const INSENSITIVE_COLLATOR = new Intl.Collator(LOCALE, {
  numeric: true,
  sensitivity: "accent",
});

@Component({
  selector: `bfx-order-details`,
  templateUrl: "./html/bfx-order-details.html",
  // BfxOrderDetailsContextMenuService is stateful so inject one per open order details -dc
  providers: [BfxOrderDetailsContextMenuService],
  standalone: false,
})
export class BfxOrderDetailsComponent
  implements OnInit, GoldenLayoutComponent, AfterViewInit, OnDestroy
{
  @ViewChild("tabView") tabView: TabView;

  @ViewChild("popupBody") mainContainer: ElementRef;
  @ViewChild("strategyLayoutPS")
  private strategyLayoutPS: PerfectScrollbarComponent;
  @ViewChild("strategyLayoutTarget") private strategyLayoutTarget: ElementRef;

  private embeddedTradeBlotter: BfxTradeBlotterComponent;

  @ViewChild("embeddedTradeBlotter") set embeddedTradeBlotterElement(
    component: BfxTradeBlotterComponent,
  ) {
    if (component) {
      this.embeddedTradeBlotter = component;
    }
  }

  private embeddedRiskTradeBlotter: BfxTradeBlotterComponent;
  @ViewChild("embeddedRiskTradeBlotter") set embeddedRiskTradeBlotterElement(
    component: BfxTradeBlotterComponent,
  ) {
    if (component) {
      this.embeddedRiskTradeBlotter = component;
    }
  }

  private embeddedAllocationsBlotter: BfxAllocationsBlotterComponent;
  @ViewChild("embeddedAllocationsBlotter")
  set embeddedAllocationBlotterElement(component: BfxAllocationsBlotterComponent) {
    if (component) {
      this.embeddedAllocationsBlotter = component;
      this.restoreAllocationBlotterConfiguration();
    }
  }

  /** GAmma rung details passed to the bfx-gamma-rungs-panel component */
  public gammaRungs: Array<CubiqTS.OrderDataImpl>;
  public selectedIds: any;
  public tradeDealSelectedIds: any;
  public allocationId: string;
  public selectedTradeId: string;
  public selectedRiskTradeId: string;
  public selectedAllocationDealId: string;
  public currencyPairIds: Set<string> = new Set<string>();
  public parentPopup: GoldenLayoutPopout;
  public embeddedTradeCount: number | null = null;
  public embeddedRiskTradeCount: number | null = null;
  public embeddedAllocationsCount: number | null = null;
  public currentLadderBlotter: any;
  public markupEnabled: boolean = false;
  public selectedDIEventIds: any;
  public isContextMenuEmpty: boolean = false;
  public clientTraderUsersEnabled = true;
  public enablePrivateComments: boolean = false;
  public displayUserNames: boolean = false;
  public fwdEnabled: boolean = false;
  public ndfEnabled: boolean = false;
  public benchmarksEnabled: boolean = false;
  public isNdfOrder: boolean = false;
  public isBenchmark: boolean = true; // NOTE: needs to be true because of template initialization of base blotter
  public isBenchmarkClientOrder: boolean = false;
  public isBenchmarkHedgeOrder: boolean = true;
  public isBenchmarkAlgoOrder: boolean = false;
  public isBenchmarkOrder: boolean = false;
  /** IS this a multi-account BM - change account display if so */
  public isMultiAccountBenchmark: boolean = false;
  public isGamma: boolean = false;
  public tabIndex: number;
  public viewTradesEnabled: boolean = false;
  public blotterInstance: any = null;
  private openTradeTab: boolean = false;
  private openRiskTradeTab: boolean = false;

  public allocationToggleVisible: boolean = false;

  public NDF_MIN_COMMENT_WINDOW_HEIGHT = "77px";
  public MIN_COMMENT_WINDOW_HEIGHT = "68px";

  public productString: string = null;
  public intentString: string = null;
  public intentType: CubiqTS.OrderIntent = null;
  public amountString: string = null;
  public valueDateString: string = null;
  public summary: string = null;

  public strategyScrollHeight: number = 401;
  public strategyTargetHeight: number = 396;
  public viewInitComplete: boolean = false;

  public ccyPair: string = "";

  public oboEnabled: boolean = false;

  public OI = CubiqTS.OrderIntent;

  /**
   * see this.parentPopup.embeddedComponentConfig.data
   */
  public persistEmbeddedComponentConfigData: boolean = true;

  private requestRef: string;
  public showPassThroughTab: boolean = true;

  public tableDefinition: TableDefinition;

  // make available to template
  public BfxConfigIDRefHelper = BfxConfigIDRefHelper;

  public tabHeaders: {
    orderDetails: string;
    monitoring: string;
    strategyParams: string;
    passThrough: string;
    comments: string;
    clientTrades: string;
    riskTrades: string;
    allocations: string;
  } = {
    orderDetails: "Order Details",
    monitoring: "Monitoring",
    strategyParams: "Strategy Params",
    passThrough: "User Defined Fields",
    comments: "Comments",
    clientTrades: "Client Trades",
    riskTrades: "Risk Trades",
    allocations: "Allocations",
  };

  public tabTitles: {
    orderDetails: string;
    monitoring: string;
    strategyParams: string;
    passThrough: string;
    comments: string;
    clientTrades: string;
    riskTrades: string;
    allocations: string;
  } = {
    orderDetails: "Order Details",
    monitoring: "Monitoring",
    strategyParams: "Strategy Parameters",
    passThrough: "Custom Fields and Pass-Through Parameters",
    comments: "Comments",
    clientTrades: "Client Trades",
    riskTrades: "Risk Trades",
    allocations: "Allocations",
  };

  // this must match semantics of TableDefinition model
  private embeddedTradeColumnAllowListOverrideConfig: Map<string, object> = new Map<string, object>(
    [
      [
        "selection",
        {
          hide: false,
          omitFromPicker: true,
          position: 0,
          resizable: true,
        },
      ],
      [
        "id",
        {
          name: "Trade Id",
          hide: false,
          omitFromPicker: false,
          position: 1,
          resizable: true,
        },
      ],
      // Leave Position 2 for Order ID in Gamma orders
      [
        "accountCode",
        {
          hide: true,
          omitFromPicker: false,
          position: 3,
          resizable: true,
        },
      ],
      [
        "isBuy",
        {
          hide: false,
          omitFromPicker: true,
          position: 4,
          resizable: true,
        },
      ],
      [
        "dealtCcy",
        {
          name: "Dealt Ccy",
          hide: false,
          omitFromPicker: true,
          position: 5,
          resizable: true,
        },
      ],
      [
        "amt1",
        {
          name: "Fill Amt",
          hide: false,
          omitFromPicker: true,
          position: 6,
          resizable: true,
        },
      ],
      [
        "spotMarketRate",
        {
          hide: false,
          omitFromPicker: false,
          position: 7,
          resizable: true,
        },
      ],
      // Forward Market Pts position 8
      // Fwd Market Rate position 9
      [
        "spotClientRate",
        {
          hide: false,
          omitFromPicker: true,
          position: 10,
          resizable: true,
        },
      ],
      // Forward points position 11
      // All in client Rate position 12
      [
        "salesMargin",
        {
          hide: false,
          omitFromPicker: false,
          position: 13,
          resizable: true,
        },
      ],
      [
        "counterCcy",
        {
          name: "Counter Ccy",
          hide: false,
          omitFromPicker: true,
          position: 14,
          resizable: true,
        },
      ],
      [
        "amt2",
        {
          hide: false,
          omitFromPicker: false,
          position: 15,
          resizable: true,
        },
      ],
      [
        "valueDate",
        {
          hide: false,
          omitFromPicker: false,
          position: 16,
          resizable: true,
        },
      ],
      [
        "dealState",
        {
          omitFromPicker: false,
          hide: false,
          position: 17,
          resizable: true,
        },
      ],
      [
        "creationDate",
        {
          name: "Fill Time",
          hide: false,
          omitFromPicker: false,
          position: 18,
          resizable: true,
        },
      ],
      [
        "dealStateId",
        {
          hide: false,
          omitFromPicker: false,
          position: 19,
          resizable: true,
        },
      ],
      [
        "aggregateRef",
        {
          hide: false,
          omitFromPicker: false,
          position: 20,
          resizable: true,
        },
      ],
    ],
  );

  private forwardEnabledColumns: Map<string, object> = new Map<string, object>([
    [
      "forwardMarketPoints",
      {
        hide: false,
        omitFromPicker: false,
        position: 8,
      },
    ],
    [
      "forwardMarketRate",
      {
        hide: false,
        omitFromPicker: false,
        position: 9,
      },
    ],
    [
      "forwardPoints",
      {
        hide: false,
        omitFromPicker: false,
        position: 11,
      },
    ],
    [
      "allInClientRate",
      {
        hide: false,
        omitFromPicker: false,
        position: 12,
      },
    ],
  ]);

  private riskEnabledColumns: Map<string, object> = new Map<string, object>([
    [
      "lastMkt",
      {
        hide: false,
        omitFromPicker: false,
        position: 13,
      },
    ],
    [
      "makerDealRef",
      {
        hide: false,
        omitFromPicker: false,
        position: 14,
      },
    ],
    [
      "secondaryMakerDealRef",
      {
        hide: false,
        omitFromPicker: false,
        position: 15,
      },
    ],
  ]);

  /** List of visible custom fields sorted by ID */
  customFieldDefns: Array<CubiqTS.CustomField>;
  private orderAmountHelper: BMOrderAmountHelper;
  private valueDateHelper: ValueDateHelper;

  private subscriptionOrderData: Subscription;
  private subscriptionDeal: Subscription;
  private subscriptionBulkOrderData: Subscription;
  private subcriptionBenchmarkLock: Subscription;
  private subscriptionPause: Subscription;
  private subscriptionXfer: Subscription;

  private subjectReload: Subject<string>;

  private autoReloadMinInterval: number = 2000;
  public orderDetails: any = {};

  public mediatedOrderDetails: any = {};

  public errorMessage: string = null;

  private initData: {
    data: any;
    container: any;
    state: any;
  } = null;

  public control: {
    mode: boolean;
    hasOrderDetails: boolean;
    sysConfigsPrimed: boolean;
    hasErrorMessage: boolean;
    embeddedTradeBlotterLoaded: boolean;
    embeddedTradeBlotterVisible: boolean;
    containerHeight: 324;
    scrollbarConfig: {
      suppressScrollX: boolean;
    };
    strategyData: any;
    hasStrategy: boolean;
    showStrategy: boolean;
    panzoom: any;
    strategyLayout: any;
  } = {
    mode: true,
    hasOrderDetails: false,
    sysConfigsPrimed: false,
    hasErrorMessage: false,
    embeddedTradeBlotterLoaded: false,
    embeddedTradeBlotterVisible: false,
    containerHeight: 324,
    scrollbarConfig: {
      suppressScrollX: false,
    },
    strategyData: null,
    hasStrategy: false,
    showStrategy: false,
    panzoom: null,
    strategyLayout: null,
  };

  public config: any = {
    debug: false,
  };

  constructor(
    protected columnSelectorService: BfxBaseBlotterColumnSelectorService,
    private _detailedOrderService: DetailedOrderStatusRequestPromiseService,
    private _contextMenuService: BfxOrderDetailsContextMenuService,
    private _ordersActionService: BfxBlotterOrdersActionService,
    private ngZone: NgZone,
    private dealDetailsService: BfxDealDetailsService,
    private sysConfigService: SystemConfigPromiseService,
    private translateService: TranslateService,
    public el: ElementRef,
    protected profileActionService: ProfilePromiseActionService,
    protected configService: BfxConfigService,
    protected customFieldService: CustomFieldPromiseLookupService,
    protected ccyLookupService: CcyLookupService,
    protected ccyPairCalSvc: CurrencyPairCalendarLookupService,
    protected traderGroupService: TraderGroupPromiseLookupService,
    protected cubiqWorker: CubiqWorker,
    protected contextMenuService: BfxTradeDetailsContextMenuService,
  ) {
    this.blotterInstance = this;

    configService.getUIConfig().then((config) => {
      this.oboEnabled = config && config.general ? config.general.oboEnabled : false;
    });

    this.orderAmountHelper = new BMOrderAmountHelper(ccyLookupService);
    this.valueDateHelper = new ValueDateHelper(ccyPairCalSvc);

    this.initialize();
  }

  ngOnInit(): void {
    Promise.all([
      this.sysConfigService.getSystemConfig(SysFeatures.markupEnabled),
      this.sysConfigService.getSystemConfig(SysFeatures.clientTraderUsersEnabled),
      this.sysConfigService.getSystemConfig(SysFeatures.featuresEnablePrivateComments),
      this.sysConfigService.getSystemConfig(SysFeatures.displayUserNames),
      this.sysConfigService.getSystemConfig(SysFeatures.fwdEnabled),
      this.sysConfigService.getSystemConfig(SysFeatures.ndfEnabled),
      this.sysConfigService.getSystemConfig(SysFeatures.benchmarksEnabled),
      this.sysConfigService.getSystemConfig(SysFeatures.orderDetailsReloadInterval),
    ])
      .then(
        (values) => {
          this.markupEnabled = "Y" == values[0];
          this.clientTraderUsersEnabled = "Y" == values[1];
          this.enablePrivateComments = "Y" == values[2];
          this.displayUserNames = "Y" == values[3];
          this.fwdEnabled = "Y" == values[4];
          this.ndfEnabled = "Y" == values[5];
          this.benchmarksEnabled = "Y" == values[6];

          if (values[7] != null) {
            try {
              let value = parseInt(values[7].trim());
              if (value > 0) {
                this.autoReloadMinInterval = value;
                logger.out.debug(`Order details auto reload set to ${value}ms`);
              } else {
                this.autoReloadMinInterval = 0;
                this.closeSubscriptions();
                logger.out.debug(
                  `${this.constructor.name} Config ` +
                    `${SysFeatures.orderDetailsReloadInterval} with value ${values[7]}.` +
                    `Order details live updating will be disabled.`,
                );
              }
            } catch (e) {
              logger.out.error(
                `${this.constructor.name} Could not parse config ` +
                  `${SysFeatures.orderDetailsReloadInterval} with value ${values[7]}.` +
                  `Defaulting to ${this.autoReloadMinInterval}ms`,
              );
            }
          }

          this.control.sysConfigsPrimed = true;
        },
        (rejection) => {
          logger.out.error(
            "ERROR:BfxBlotterFilterService getTableDefinition rejection:",
            rejection,
          );
        },
      )
      .catch((reason) => {
        logger.out.error("ERROR:BfxBlotterFilterService getTableDefinition reason: ", reason);
      });
  }

  private initialize() {
    this.initializeCustomFieldDefns();
  }

  ngAfterViewInit(): void {
    // NOTE: to be considered for deleting since there is new mechanism for displaying.
    // setTimeout(() => {
    //   // Hide Trades tab for benchmark order
    //   if (this.benchmarksEnabled && this.orderDetails && this.orderDetails.isBenchmarkOrder) {
    //     this.tabView.closeTab(this.tradesTab);
    //   } else if (this.embeddedTradeBlotter) {
    //     this.embeddedTradeBlotter.embeddedTableMode = true;
    //   }

    // }, 200);

    let counter = 0;
    let intervalHook = setInterval(() => {
      if (this.control.sysConfigsPrimed && this.control.hasOrderDetails) {
        if (this.control.hasStrategy) {
          this.resizeStrategy();
          this.viewInitComplete = true;
        } else {
          counter++;
        }
        if (this.control.hasOrderDetails) {
          this.trades_show();
          if (this.openTradeTab) {
            this.openTradesTab();
          } else if (this.openRiskTradeTab) {
            this.openRiskTradesTab();
          }
        }
        clearInterval(intervalHook);
      } else if ((this.control.hasErrorMessage && !this.control.hasOrderDetails) || counter > 10) {
        clearInterval(intervalHook);
      } else {
        counter++;
      }
    }, 250);
  }

  ngOnDestroy() {
    this.closeSubscriptions();
    this.viewInitComplete = false;
  }

  reload(id: string = null): void {
    if (id != null) {
      logger.out.info(
        `${this.constructor.name}: Auto reloading order details` +
          ` [${this.parentPopup?.title}], update on order ${id}`,
      );
    } else {
      logger.out.info(
        `${this.constructor.name}: Reloading order details ` + `[${this.parentPopup?.title}]`,
      );
    }

    if (this.initData != null) {
      this.control.embeddedTradeBlotterLoaded = false;
      if (this.parentPopup) {
        this.parentPopup.disabledRefresh = true;
      }
      this.glInit(this.initData.data, this.initData.container, this.initData.state, true);
    } else {
      logger.out.error(
        `${this.constructor.name}: Could not find initial data to reload ` + `order details`,
      );
    }
  }

  protected initReloadData(data: any, container: any, state: any): void {
    if (this.initData == null) {
      this.initData = {
        data: {
          selectedIds: data.selectedIds,
          selectedDIEventIds: data.selectedDIEventIds,
          tradeDealSelectedIds: data.tradeDealSelectedIds,
        },
        container: container,
        state: state,
      };

      if (this.autoReloadMinInterval > 0) {
        this.initReloadSubscriptions();
      }
    }
  }

  protected initReloadSubscriptions(): void {
    if (this.subjectReload == null) {
      this.subjectReload = new Subject<string>();
      this.subjectReload
        .pipe(
          throttleTime(this.autoReloadMinInterval, asyncScheduler, {
            leading: true,
            trailing: true,
          }),
        )
        .subscribe(this.reload.bind(this));
    }

    if (this.subscriptionOrderData == null) {
      this.subscriptionOrderData = this.cubiqWorker
        .getEncodableObservable(CubiqTS.OrderLifeCycleEventImpl.name)
        .subscribe(this.onOrderLifecycleEvent.bind(this));
    }

    if (this.subscriptionDeal == null) {
      this.subscriptionDeal = this.cubiqWorker
        .getEncodableObservable(CubiqTS.DealImpl.name)
        .subscribe(this.onDealEvent.bind(this));
    }

    if (this.subscriptionBulkOrderData == null) {
      this.subscriptionBulkOrderData = this.cubiqWorker
        .getEncodableObservable(CubiqTS.BulkOrderLifeCycleEventImpl.name)
        .subscribe(this.onBulkOrderLifecycleEvent.bind(this));
    }

    if (this.subcriptionBenchmarkLock == null) {
      this.subcriptionBenchmarkLock = this.cubiqWorker
        .getEncodableObservable(CubiqTS.BenchmarkLockLifeCycleEventImpl.name)
        .subscribe(this.onBenchmarkLockEvent.bind(this));
    }

    if (this.subscriptionPause == null) {
      this.subscriptionPause = this.cubiqWorker
        .getEncodableObservable(CubiqTS.PauseLifeCycleEventImpl.name)
        .subscribe(this.onPauseEvent.bind(this));
    }

    if (this.subscriptionXfer == null) {
      this.subscriptionXfer = this.cubiqWorker
        .getEncodableObservable(CubiqTS.XferEventImpl.name)
        .subscribe(this.onXferEvent.bind(this));
    }
  }

  // Golden layout popout component creation callback
  glInit(data: any, container: any, state: any, reload: boolean = false): void {
    this.initReloadData(data, container, state);

    if (!reload) {
      this.currentLadderBlotter =
        container != null
          ? container._config != null
            ? container._config.ladderBlotter != null
              ? container._config.ladderBlotter
              : null
            : null
          : null;

      this.openTradeTab = typeof data.openTradesTab === "boolean" ? data.openTradesTab : false;
      this.openRiskTradeTab =
        typeof data.openRiskTradesTab === "boolean" ? data.openRiskTradesTab : false;
    }

    if (data.selectedDIEventIds) {
      this.selectedDIEventIds = data.selectedDIEventIds;
      this._contextMenuService.setSelectedDIEventIds(data.selectedDIEventIds);
    }
    if (data.tradeDealSelectedIds) {
      this.tradeDealSelectedIds = data.tradeDealSelectedIds;

      const tradeOrderIds = this.getTradeIds();
      this._detailedOrderService.requestAdaptedTradeDeals(tradeOrderIds).then(
        (tradeDeals: any[]) => {
          let tradeDeal = tradeDeals.find((td) => {
            return td && td.id == this.tradeDealSelectedIds[0];
          });
          if (!(tradeDeal && tradeDeal.orderId)) {
            logger.out.error(
              `${this.constructor.name}.glInit() can not determine orderId of trade`,
            );
            return;
          }

          this.selectedIds = [tradeDeal.orderId];

          this.trades_show();

          this.initMediatedOrderDetails(reload);
        },
        (reason) => {
          this.setError(reason);
        },
      );
    } else {
      this.selectedIds = data.selectedIds;

      this.initMediatedOrderDetails(reload);
    }
  }

  /**
   * Get array of all order IDs to use when requesting deals
   * @returns
   */
  private getTradeIds(): Array<string> {
    if (this.isGamma && this.gammaRungs) {
      return this.gammaRungs.map((order) => order.orderId.toString());
    }
    const retIds: Array<string> = [];
    if (this.selectedIds) {
      retIds.push(this.selectedIds[0]);
    } else {
      // Returning an empty array will actually return all trade deals in the DB
      retIds.push("-1");
    }
    return retIds;
  }

  public generateSummary(): string {
    const orderDetails = this.orderDetails;
    const order: CubiqTS.OrderDataImpl = orderDetails?.orderData;
    let ret: string = null;

    if (orderDetails == null) {
      return ret;
    }

    if (order != null) {
      this.updateSummaryStrings(order, orderDetails);
    }

    if (this.isGamma) {
      return this.generateGammaSummary(orderDetails);
    }

    switch (orderDetails.requestedOrderType) {
      case CubiqTS.RequestOrderType.TP:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        ret = this.generateTPSLSummary(orderDetails);
        break;
      case CubiqTS.RequestOrderType.CALL:
        ret = this.generateCALLSummary(orderDetails);
        break;
      case CubiqTS.RequestOrderType.MARKET:
      case CubiqTS.RequestOrderType.ALGO:
        ret = this.generateMarketALGOSummary(orderDetails);
        break;
      case CubiqTS.RequestOrderType.BMARK:
      case CubiqTS.RequestOrderType.BMALGO:
        ret = this.generateBMSummary(orderDetails);
        break;
      default:
        ret = null;
        logger.out.warn(
          `WARNING: BfxOrderDetailsComponent.craftSummary(): Unsupported order type: ${orderDetails.type}`,
        );
        break;
    }
    return ret;
  }

  private getRiskData(orderDetails: any, order: CubiqTS.OrderDataImpl) {
    let riskData: BmarkRiskData = null;

    if (orderDetails.requestedOrderType === CubiqTS.RequestOrderType.BMARK) {
      const riskMap = BMRiskUtils.createRiskMap(order.allocationData);
      const values = riskMap.values();

      let retRiskData: RiskData = null;
      // Copied from BmarkOrderData.model.ts
      if (riskMap.size == 1) {
        retRiskData = riskMap.values().next().value;
      } else {
        for (const value of values) {
          if (value.isDealt) {
            retRiskData = value;
            break;
          }
        }
      }

      riskData = new BmarkRiskData(order, retRiskData.allocations);
    }
    return riskData;
  }

  private updateSummaryStrings(order: CubiqTS.OrderDataImpl, orderDetails: any) {
    let riskData = this.getRiskData(orderDetails, order);

    this.intentString = this.generateIntentString(order, riskData, orderDetails);

    this.intentType = this.determineIntentType(order, riskData);

    this.productString = this.generateProductString(order, orderDetails);

    this.amountString = this.generateAmountString(riskData, orderDetails);

    this.valueDateString = this.generateValueDateString(order, riskData, orderDetails);
  }

  generateMarketALGOSummary(orderDetails: any): string {
    return `${orderDetails.clientName} ${orderDetails.instrument} ${
      orderDetails.dir
    }s ${orderDetails.orderAmt.replace(orderDetails.dealtCcy, "")} ${orderDetails.dealtCcy} ${
      orderDetails.type
    }`;
  }

  generateTPSLSummary(orderDetails: any): string {
    return `${orderDetails.clientName} ${orderDetails.instrument} ${
      orderDetails.dir
    }s ${orderDetails.orderAmt.replace(orderDetails.dealtCcy, "")} ${orderDetails.dealtCcy} ${
      orderDetails.requestRt
    } ${orderDetails.type}`; //
  }

  generateCALLSummary(orderDetails: any): string {
    return `${orderDetails.clientName} ${orderDetails.instrument} ${orderDetails.requestRt} ${orderDetails.type}`; //
  }

  generateGammaSummary(orderDetails: any): string {
    return `${orderDetails.clientName} ${orderDetails.instrument} GAMMA`;
  }

  generateBMSummary(orderDetails: any): string {
    return `${orderDetails.clientName} ${orderDetails.instrument} ${this.intentString} ${this.amountString} ${this.productString} ${this.valueDateString}`; //
  }

  private processViewTradesButtonState(): void {
    let header = this.tabView.findSelectedTab()?.header,
      th = this.tabHeaders;

    let tradeHeaders: string[] = [th.clientTrades, th.riskTrades, th.allocations];
    let blotters: BfxBaseBlotter[] = [
      this.embeddedTradeBlotter,
      this.embeddedRiskTradeBlotter,
      this.embeddedAllocationsBlotter,
    ];

    let selectedIndex = tradeHeaders.findIndex((tradeHeader, i) => {
      return (
        header === tradeHeader &&
        blotters[i] != null &&
        blotters[i].gridOptions.api.getSelectedRows().length == 1
      );
    });

    const hasSelectedItemId =
      this.selectedTradeId != null ||
      this.selectedAllocationDealId != null ||
      this.selectedRiskTradeId != null;

    this.viewTradesEnabled = selectedIndex >= 0 && hasSelectedItemId;
  }

  initMediatedOrderDetails(reloadTrades: boolean = false) {
    let id = this.selectedIds[0];

    this._detailedOrderService.requestMediatedOrderDetails(id).then(
      (mediatedOrderDetails: any) => {
        // Set to false and enable if any parameters defined on any leg
        this.showPassThroughTab = false;

        mediatedOrderDetails.orderDetails.forEach((orderDetail) => {
          let ot = orderDetail["type"];
          if (null != ot && "MARKET" == ot) {
            orderDetail["type"] = "MKT";
          }

          if (orderDetail["entryUserType"] != null) {
            let userType: string = CubiqTS.UserType[orderDetail["entryUserType"]];
            orderDetail["entryUserType"] =
              userType[0].toUpperCase() + userType.substring(1).toLowerCase();
          }

          if (orderDetail["contactData"] != null) {
            orderDetail["contacts"] = orderDetail["contacts"].split(",").join(", ");
            orderDetail["contactData"] = JSON.parse(orderDetail["contactData"]);
            orderDetail["contactData"].forEach((element) => {
              // fallbacks in case there is no text
              element.notifyEntry = CubiqTS.NotificationMethod[element.notifyEntry];
              element.notifyExpiry = CubiqTS.NotificationMethod[element.notifyExpiry];
              element.notifyFill = CubiqTS.NotificationMethod[element.notifyFill];
              element.notifyModify = CubiqTS.NotificationMethod[element.notifyModify];
              element.notifyCancel = CubiqTS.NotificationMethod[element.notifyCancel];

              let key = "NotificationMethod." + element.notifyEntry;
              element.notifyEntry = this.translateService.instant(key);

              key = "NotificationMethod." + element.notifyExpiry;
              element.notifyExpiry = this.translateService.instant(key);

              key = "NotificationMethod." + element.notifyFill;
              element.notifyFill = this.translateService.instant(key);

              key = "NotificationMethod." + element.notifyModify;
              element.notifyModify = this.translateService.instant(key);

              key = "NotificationMethod." + element.notifyCancel;
              element.notifyCancel = this.translateService.instant(key);
            });
          } else {
            orderDetail["contacts"] = null;
            orderDetail["contactData"] = null;
          }

          // Update parameters for all legs on loading of mediated order

          // First ensure all parameters are sorted
          if (
            Array.isArray(orderDetail.strategyParameters) &&
            orderDetail.strategyParameters.length > 1
          ) {
            orderDetail.strategyParameters = orderDetail.strategyParameters.sort(
              (a: CubiqTS.StrategyParameterImpl, b: CubiqTS.StrategyParameterImpl) => {
                return a.parameterName.localeCompare(b.parameterName);
              },
            );
          }
          if (
            Array.isArray(orderDetail.passThroughParameters) &&
            orderDetail.passThroughParameters.length > 0
          ) {
            orderDetail.passThroughParameters = orderDetail.passThroughParameters
              .sort((a: CubiqTS.StrategyParameterImpl, b: CubiqTS.StrategyParameterImpl) => {
                if (a.regGrp != null && b.regGrp == null) {
                  return -1;
                } else if (a.regGrp == null && b.regGrp != null) {
                  return -1;
                } else if (a.regGrp != null && b.regGrp != null) {
                  return INSENSITIVE_COLLATOR.compare(a.regGrp, b.regGrp);
                } else {
                  return a.parameterName.localeCompare(b.parameterName);
                }
              })
              .map((a) => {
                return {
                  label: a.parameterName,
                  value: a.parameterValue,
                  type: "Pass-Through Parameter",
                };
              });
          }
          if (this.customFieldsEnabled()) {
            if (orderDetail.passThroughParameters == null) {
              orderDetail.passThroughParameters = [];
            }

            let count = this.customFieldDefns.length;
            for (let i: number = count - 1; i >= 0; i--) {
              if (this.customFieldEnabled(i)) {
                orderDetail.passThroughParameters.unshift({
                  label: this.customFieldHeading(i),
                  value: this.customFieldValue(i, orderDetail.customValues),
                  type: "Custom Field",
                });
              }
            }
          }
          this.showPassThroughTab =
            this.showPassThroughTab || orderDetail.passThroughParameters?.length > 0;
        });

        this.mediatedOrderDetails = mediatedOrderDetails;
        this.isGamma = this.mediatedOrderDetails.strategyType == CubiqTS.StrategyType.GAMMA;
        this.gammaRungs = this.mediatedOrderDetails.gammaRungs;
        this.orderDetails = this.mediatedOrderDetails.orderDetails.get(id);
        this.isBenchmark = this.orderDetails.isBenchmark;
        this.isBenchmarkClientOrder = this.orderDetails.isBenchmarkClientOrder;
        this.isBenchmarkHedgeOrder = this.orderDetails.isBenchmarkHedgeOrder;
        this.isBenchmarkAlgoOrder = this.orderDetails.isBenchmarkAlgoOrder;
        this.isBenchmarkOrder = this.orderDetails.isBenchmarkOrder;

        this.processOrderAllocations();

        this.summary = this.generateSummary();

        if (this.orderDetails.allocationData != null) {
          this.embeddedAllocationsCount = this.orderDetails["allocationsCount"];
        }

        // if (this.orderDetails["tradesCount"] != null) {
        //   this.embeddedTradeCount = this.orderDetails["tradesCount"];
        // }

        if (
          this.orderDetails["product"] === CubiqTS.Product[CubiqTS.Product.NDF] ||
          this.orderDetails["product"] === `${CubiqTS.Product[CubiqTS.Product.NDF]} (Spot)`
        ) {
          this.isNdfOrder = true;
          this.parentPopup.addContainerClass("order-type-ndf");
        }

        if (this.orderDetails.isBenchmarkAlgoOrder) {
          this.parentPopup.addContainerClass("order-type-bmarkAlgo");
        }

        if (this.orderDetails["__bfx_order_details_request_ref"])
          this.requestRef = this.orderDetails["__bfx_order_details_request_ref"];

        let title: string;
        if (this.isGamma) {
          title = this.translateService.instant("order.details.gamma_title", [
            BfxConfigIDRefHelper.getStrategyRef(this.orderDetails),
          ]);
        } else {
          title = this.translateService.instant("order.details.title", [
            BfxConfigIDRefHelper.getOrderRef(this.orderDetails),
          ]);
        }
        this.parentPopup.title = title;
        this.control.hasOrderDetails = true;

        if (reloadTrades) {
          this.trades_show();
        }

        setTimeout(() => {
          // delayed visibility application of strategy panel solves the scrollbar dragging problem on desktop
          if (this.isGamma) {
            this.parentPopup.addContainerClass("has-gamma");
            this.parentPopup.disabledRefresh = false;
          } else if (this.mediatedOrderDetails.orderDetails.size > 1) {
            this.control.hasStrategy = true;

            this.parentPopup.addContainerClass("has-strategy");

            setTimeout(() => {
              let strategyData = this.mediatedOrderDetails.strategyData;
              let target = this.strategyLayoutTarget.nativeElement;
              let panzoom = null;
              let strategyLayout = null;

              this.control.strategyLayout = strategyLayout = d3.layout
                .strategy()
                .render(strategyData, target, id.toString(), this.strategySelected.bind(this));
              this.strategyLayoutPS.directiveRef.update();
              this.parentPopup.disabledRefresh = false;
            }, 4);
          } else {
            this.control.hasStrategy = false;

            this.parentPopup.removeContainerClass("has-strategy");
            this.parentPopup.disabledRefresh = false;
          }
        }, 0);
      },
      (reason) => {
        this.setError(reason);
        this.parentPopup.disabledRefresh = false;
      },
    );
  }

  private generateValueDateString(
    order: CubiqTS.OrderDataImpl,
    risks: BmarkRiskData,
    data: any,
  ): any {
    if (order != null && risks != null) {
      return ValueDateRenderer.render(
        order.settleDate,
        order.settleTenor,
        risks.isSwap,
        risks.isSSP,
        risks.nearTenor,
        risks.nearValueDate,
        risks.farTenor,
        risks.farValueDate,
        this.valueDateHelper,
      );
    }

    return data?.valueDt;
  }

  private generateAmountString(risks: BmarkRiskData, data: any): string {
    if (risks != null) {
      return this.orderAmountHelper.formatAmount(
        risks.fixedCcy,
        risks.riskAmount,
        risks.isSwap,
        risks.nearAmount,
        risks.farAmount,
        true,
      );
    }

    return data?.orderAmt;
  }

  private generateProductString(order: CubiqTS.OrderDataImpl, data: any): string {
    return order != null && Array.isArray(order.allocationData)
      ? ProductRenderer.render(order.product, order.requestTrackingType, order.orderType)
      : data?.product;
  }

  private determineIntentType(
    order: CubiqTS.OrderDataImpl,
    risk: BmarkRiskData,
  ): CubiqTS.OrderIntent {
    let result: CubiqTS.OrderIntent = null;

    if (order != null && Array.isArray(order.allocationData) && null != risk) {
      let risks: RiskAggregate = null;

      if (risk.allocations != null) {
        risks = BMRiskUtils.aggregateAllocations(risk.fixedCcy, order.product, risk.allocations);
      }

      if (CubiqTS.Product.SWP == order.product) {
        result = risk.farIntent;
      } else if (risks != null && risks.allocations != null && risks.allocations.length > 1) {
        result = risks.clientIntent;
      } else {
        result = order.clientIntent;
      }
    } else if (
      CubiqTS.RequestOrderType.CALL != order.requestedOrderType &&
      CubiqTS.StrategyType.GAMMA != order.strategyType
    ) {
      result = order.clientIntent;
    }

    return result;
  }

  private generateIntentString(
    order: CubiqTS.OrderDataImpl,
    risks: BmarkRiskData,
    data: any,
  ): string {
    if (order != null && Array.isArray(order.allocationData) && null != risks) {
      return ProductIntentRenderer.render(
        risks.clientIntent,
        risks.fixedCcy,
        order.product,
        order.requestedOrderType,
        risks.allocations,
        risks,
      );
    }

    return data.dir;
  }

  public get desktop(): boolean {
    return NativeDesktopSupport.isNativeDesktopContainer();
  }

  strategySelected(strategyId: string): boolean {
    return true;
  }

  renderPanZoom() {
    if (this.control.strategyLayout === null) {
      return;
    }

    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        // 2. svgPanZoom is non-angular
        this.control.panzoom = svgPanZoom(this.control.strategyLayout.node(), {
          controlIconsEnabled: true,
          zoomEnabled: true,
          dblClickZoomEnabled: false,
          mouseWheelZoomEnabled: true,
          preventMouseEventsDefault: true,
          zoomScaleSensitivity: 0.2,
          minZoom: 0.75,
          maxZoom: 1.5,
          fit: false,
          contain: false,
          center: false,
          beforePan: function (oldPan, newPan) {
            let stopHorizontal = false,
              stopVertical = false,
              gutterWidth = 100,
              gutterHeight = 100,
              // Computed variables
              sizes = this.getSizes(),
              leftLimit =
                -((sizes.viewBox.x + sizes.viewBox.maxWidth) * sizes.realZoom) + gutterWidth,
              rightLimit = sizes.maxWidth - gutterWidth - sizes.viewBox.x * sizes.realZoom,
              topLimit =
                -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
              bottomLimit = sizes.height - gutterHeight - sizes.viewBox.y * sizes.realZoom;
            let customPan: any = {};
            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
            return customPan;
          },
        });
      });
    }, 4);
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
    this.parentPopup.setShowRefresh(true);
    this.restoreAllocationBlotterConfiguration();
  }

  /**
   * Apply the allocation blotter config stored in the parent popup
   */
  private restoreAllocationBlotterConfiguration() {
    let config: any;
    if (this.parentPopup && this.embeddedAllocationsBlotter) {
      let embeddedConfig = this.parentPopup.embeddedComponentConfig;
      if (embeddedConfig) {
        if (
          EMBEDDED_COMPONENT_CONFIG_VER ===
            embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] &&
          embeddedConfig.data[EMBEDDED_ALLOCATIONS_BLOTTER_CONFIG_PROPERTY]
        ) {
          config = embeddedConfig.data[EMBEDDED_ALLOCATIONS_BLOTTER_CONFIG_PROPERTY];
          this.embeddedAllocationsBlotter.restoreConfiguration(config);
        }
      }
    }
  }

  actions_show($event: MouseEvent) {
    this._contextMenuService.hideMenu(this.currentLadderBlotter);

    this._contextMenuService.doMenu(
      this.currentLadderBlotter,
      $event.x,
      $event.y,
      this.selectedIds,
      [this.orderDetails.orderData],
    );
  }

  actions_show_audit_log($event: MouseEvent) {
    let actionEvent = new BfxBlotterActionEvent(
      BfxBlotterAction.ACTION_VIEW_AUDIT,
      this.currentLadderBlotter,
      this.selectedIds,
      [this.orderDetails],
      null,
      null,
      null,
      $event,
    );

    this._ordersActionService.onViewAudit(actionEvent);
  }

  actions_view_deal_details($event: MouseEvent) {
    let header = this.tabView.findSelectedTab()?.header;

    let isAllocations = this.tabHeaders.allocations === header;
    let clientTab = this.tabHeaders.clientTrades === header;

    if (
      this.orderDetails.isBenchmarkOrder &&
      this.selectedAllocationDealId != null &&
      isAllocations
    ) {
      this.dealDetailsService.openDeal(this.selectedAllocationDealId, $event);
    } else if (clientTab && this.selectedTradeId != null) {
      this.dealDetailsService.openDeal(this.selectedTradeId, $event);
    } else if (this.selectedRiskTradeId != null) {
      this.dealDetailsService.openDeal(this.selectedRiskTradeId, $event);
    }
  }

  public allocations_show(): void {
    if (
      this.orderDetails &&
      this.orderDetails.allocationData &&
      this.orderDetails.isBenchmarkOrder
    ) {
      this.currencyPairIds = this.orderDetails.currencyPairIds;

      if (this.currencyPairIds.size > 1) {
        this.selectFirstCurrencyPair();
      }
      this.allocationToggleVisible = true;
    }
  }

  selectFirstCurrencyPair() {
    let firstCurrencyPair: string = null;
    if (null != this.currencyPairIds && this.currencyPairIds.size > 1) {
      firstCurrencyPair = this.currencyPairIds.keys().next().value;
    }

    if (null != firstCurrencyPair) {
      this.onPairChanged(firstCurrencyPair);
    }
  }

  trades_show(): void {
    if (!this.control.hasOrderDetails) {
      logger.out.warn(
        `${this.constructor.name}.trades_show() called while template has no embedded trade blotter`,
      );
    }

    this.control.embeddedTradeBlotterVisible = true;

    if (!this.control.embeddedTradeBlotterLoaded) {
      let config: any;
      let embeddedConfig = this.parentPopup.embeddedComponentConfig;
      if (
        EMBEDDED_COMPONENT_CONFIG_VER ===
          embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] &&
        embeddedConfig.data[EMBEDDED_TRADE_BLOTTER_CONFIG_PROPERTY] ===
          Object(embeddedConfig.data[EMBEDDED_TRADE_BLOTTER_CONFIG_PROPERTY])
      ) {
        config = embeddedConfig.data[EMBEDDED_TRADE_BLOTTER_CONFIG_PROPERTY];
      }

      if (
        EMBEDDED_COMPONENT_CONFIG_VER ===
          embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] &&
        embeddedConfig.data[EMBEDDED_RISK_TRADE_BLOTTER_CONFIG_PROPERTY] ===
          Object(embeddedConfig.data[EMBEDDED_RISK_TRADE_BLOTTER_CONFIG_PROPERTY])
      ) {
        config = embeddedConfig.data[EMBEDDED_RISK_TRADE_BLOTTER_CONFIG_PROPERTY];
      }

      const tradeOrderIds = this.getTradeIds();
      this._detailedOrderService.requestAdaptedTradeDeals(tradeOrderIds).then(
        (adaptedTradeDeal: any) => {
          if (this.embeddedTradeBlotter == null && !this.isBenchmarkOrder) {
            this.control.embeddedTradeBlotterLoaded = false;
            logger.out.error(
              `${this.constructor.name}.trades_show() is null.` +
                ` returning early from processing trade deals` +
                ` hasOrderDetails:${this.control.hasOrderDetails}` +
                `isBenchmarkClientOrder:${this.isBenchmarkClientOrder}`,
            );
            return;
          }

          let columnMap: Map<string, object> = this.embeddedTradeColumnAllowListOverrideConfig;

          if (this.fwdEnabled && this.ndfEnabled) {
            if (this.isNdfOrder) {
              this.forwardEnabledColumns.set("fixingDate", {
                visible: false,
                omitFromPicker: false,
                position: 16,
              });
            }
            columnMap = new Map([...columnMap, ...this.forwardEnabledColumns]);
            columnMap = this.updateColumns(config, columnMap);
          }
          if (this.isGamma) {
            // Add this here so that order Id columnb is always visible and not hidden due to config
            columnMap.set("orderId", {
              hide: false,
              omitFromPicker: false,
              position: 2,
            });
          }

          let riskTradeDeals = this.extractRiskTrades(adaptedTradeDeal);
          let rowSelectCallback = (event) => {
            if (event.node.isSelected()) {
              this.selectedTradeId = event.node.id;
            }
            this.processViewTradesButtonState();
          };

          let rowRiskSelectCallback = (event) => {
            if (event.node.isSelected()) {
              this.selectedRiskTradeId = event.node.id;
            }
            this.processViewTradesButtonState();
          };

          if (this.embeddedTradeBlotter != null) {
            this.embeddedTradeBlotter.setEmbeddedTable(adaptedTradeDeal, config, columnMap);
            this.embeddedTradeCount = adaptedTradeDeal.length;
            this.embeddedTradeBlotter.gridOptions.onSelectionChanged;
            this.embeddedTradeBlotter.gridOptions.onRowSelected = rowSelectCallback;
          }

          if (this.embeddedRiskTradeBlotter != null) {
            let riskColumnMap = new Map([...columnMap, ...this.riskEnabledColumns]);
            this.embeddedRiskTradeBlotter.setEmbeddedTable(riskTradeDeals, config, riskColumnMap);
            this.embeddedRiskTradeCount = riskTradeDeals.length;
            this.embeddedRiskTradeBlotter.gridOptions.onRowSelected = rowRiskSelectCallback;
          }
        },
        (reason) => {
          this.setError(reason);
        },
      );

      this.control.embeddedTradeBlotterLoaded = true;
    }
  }

  private extractRiskTrades(adaptedTradeDeal: CubiqTS.DealImpl[]): CubiqTS.DealImpl[] {
    let riskDeals = [];

    let i = adaptedTradeDeal.length;
    while (i--) {
      if (this.isRiskTrade(adaptedTradeDeal[i])) {
        let deal = adaptedTradeDeal[i];
        riskDeals.push(deal);
        if (!this.isClientTrade(deal)) {
          adaptedTradeDeal.splice(i, 1);
        }
      }
    }

    return riskDeals;
  }

  private isClientTrade(deal: CubiqTS.DealImpl): boolean {
    return (
      deal.spotReservationFg != true &&
      (deal.makerDealRef === null || deal.aggregateId == null || deal.aggregateId.isZero())
    );
  }

  private isRiskTrade(deal: CubiqTS.DealImpl): boolean {
    return deal.makerDealRef != null || deal.spotReservationFg === true;
  }

  private updateColumns(config: any, newColumns: Map<string, object>): Map<string, object> {
    if (config != null && config.columnsConfiguration != null) {
      let columnConfiguration = config.columnsConfiguration;
      for (const [key, value] of newColumns.entries()) {
        if (columnConfiguration.hasOwnProperty(key)) {
          value["hide"] = !columnConfiguration[key]["visible"];
          value[COLUMN_LADDER_POSITION] = columnConfiguration[key][COLUMN_LADDER_POSITION];
        }
      }
    }
    return newColumns;
  }

  trades_hide(): void {
    this.control.embeddedTradeBlotterVisible = false;
  }

  allocations_hide(): void {
    this.allocationToggleVisible = false;
  }

  onTabChange(event): void {
    this.tabIndex = event.index;

    const header = this.tabView.tabs[this.tabIndex].header;
    if (header === this.tabHeaders.allocations) {
      this.allocations_show();
      this.trades_hide();
    } else if (header === this.tabHeaders.clientTrades || header === this.tabHeaders.riskTrades) {
      this.allocations_hide();
      this.trades_show();
    } else {
      this.trades_hide();
      this.allocations_hide();
    }

    this.processViewTradesButtonState();
  }

  private openTradesTab(): void {
    let index = this.tabView.tabs.findIndex((tp) => tp.header === this.tabHeaders.clientTrades);
    if (index < 0) {
      index = this.tabView.tabs.findIndex((tp) => tp.header === this.tabHeaders.allocations);
      this.allocations_show();
    }

    if (index >= 0) {
      this.tabIndex = index;
    }
  }

  private openRiskTradesTab(): void {
    let index = this.tabView.tabs.findIndex((tp) => tp.header === this.tabHeaders.riskTrades);
    if (index >= 0) {
      this.tabIndex = index;
    }
  }

  close($event: MouseEvent) {
    if (this.requestRef) {
      this._detailedOrderService.releaseMediatedOrderDetails(this.requestRef);
      this.requestRef = null;
    }

    this.parentPopup.close();
  }

  onClose(): boolean {
    // save config
    let embeddedConfig = this.parentPopup.embeddedComponentConfig;

    this.closeSubscriptions();

    if (
      this.control.embeddedTradeBlotterLoaded &&
      this.embeddedTradeBlotter != null &&
      !this.orderDetails?.isBenchmarkOrder
    ) {
      let embeddedTradeBlotterConfig = this.embeddedTradeBlotter.getComponentConfiguration();
      embeddedConfig.data[EMBEDDED_TRADE_BLOTTER_CONFIG_PROPERTY] = embeddedTradeBlotterConfig;
      embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] = EMBEDDED_COMPONENT_CONFIG_VER;
    }

    if (this.embeddedRiskTradeBlotter != null) {
      let embeddedTradeBlotterConfig = this.embeddedRiskTradeBlotter.getComponentConfiguration();
      embeddedConfig.data[EMBEDDED_RISK_TRADE_BLOTTER_CONFIG_PROPERTY] = embeddedTradeBlotterConfig;
      embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] = EMBEDDED_COMPONENT_CONFIG_VER;
    }
    if (this.orderDetails?.isBenchmarkOrder && this.embeddedAllocationsBlotter != null) {
      let embeddedAllocationsBlotterConfig =
        this.embeddedAllocationsBlotter.getComponentConfiguration();
      embeddedConfig.data[EMBEDDED_ALLOCATIONS_BLOTTER_CONFIG_PROPERTY] =
        embeddedAllocationsBlotterConfig;
      embeddedConfig.data[EMBEDDED_COMPONENT_VERSION_PROPERTY] = EMBEDDED_COMPONENT_CONFIG_VER;
    }

    if (this.requestRef) {
      this._detailedOrderService.releaseMediatedOrderDetails(this.requestRef);
      this.requestRef = null;
    }

    return true;
  }

  public onCurrencyChange(pair: string): void {
    if (pair) {
      this.ccyPair = pair;
    }
  }

  public onPairChanged(pair: string): void {
    this.onCurrencyChange(pair);
  }

  select($event) {
    if (this.selectedIds[0] !== $event.detail.id) {
      if (this.control.embeddedTradeBlotterLoaded) {
        this.control.embeddedTradeBlotterLoaded = false;
        this.embeddedTradeCount = null;
        this.embeddedTradeBlotter.setEmbeddedTable([]);
        this.embeddedTradeBlotter.setEmbeddedTableLoadPending();
      }
      this.selectedIds = [$event.detail.id];
    }

    this.orderDetails = this.mediatedOrderDetails.orderDetails.get($event.detail.id);
    // if (this.orderDetails["tradesCount"] != null) {
    //   this.embeddedTradeCount = this.orderDetails["tradesCount"];
    // }
    this.parentPopup.title = this.orderDetails.title;
    this.summary = this.generateSummary();

    if (!this.control.embeddedTradeBlotterLoaded && this.control.embeddedTradeBlotterVisible) {
      this.trades_show();
    }
  }

  remove($event: CustomEvent) {
    logger.out.info("remove: " + ($event.detail as any).id);
  }

  setError(reason) {
    this.control.hasErrorMessage = true;
    this.control.hasOrderDetails = false;

    try {
      let msg = JSON.parse(reason);

      if (msg && msg.id) {
        if (this.translateService.instant(msg.id))
          this.errorMessage = this.translateService.instant(msg.id, msg.args);
      } else {
        this.errorMessage = reason;
      }
    } catch (e) {
      this.errorMessage = this.translateService.instant("orddet.error");
    }
  }

  public resize(): void {
    this.resizeStrategy();
  }

  public resizeStrategy(): void {
    let height = this.mainContainer.nativeElement.offsetHeight;
    let magicOffsetScroll: number = 35;
    let magicOffsetTarget: number = 42;
    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      magicOffsetScroll = 39;
      magicOffsetTarget = 46;
    }
    this.strategyScrollHeight = height - magicOffsetScroll;
    this.strategyTargetHeight = height - magicOffsetTarget;
    setTimeout(() => {
      this.strategyLayoutPS.directiveRef.update();
    }, 50);
  }

  /**
   * Retrieve all custom field definitions, strip out the non-enditable ones and sort by field ID
   */
  private initializeCustomFieldDefns(): void {
    this.customFieldService.getActiveCustomFields().then((customFields) => {
      const visibleFieldDefns: Array<CubiqTS.CustomField> = [];
      for (let defn of customFields) {
        if (defn.isEnabledFg) {
          // We only allow a maximum of 4 editable fields
          if (defn.showOnNewModifyOrderUiFg) {
            visibleFieldDefns.push(defn);
          }
        }
      }
      this.customFieldDefns = visibleFieldDefns;
    });
  }

  public customFieldsEnabled(): boolean {
    return this.customFieldDefns && this.customFieldDefns.length > 0;
  }

  public customFieldEnabled(index: number): boolean {
    return this.customFieldDefns[index] && this.customFieldDefns[index].isEnabledFg;
  }

  public customFieldHeading(index: number): string {
    if (this.customFieldEnabled(index)) {
      return this.customFieldDefns[index].displayName;
    }
    return null;
  }

  public customFieldValue(index: number, customValues: CubiqTS.CustomValueImpl[]): string {
    let retValue = "";
    if (this.customFieldEnabled(index) && Array.isArray(customValues)) {
      let fieldId = this.customFieldDefns[index].fieldId;
      for (const customValue of customValues) {
        if (customValue.fieldId === fieldId) {
          retValue = customValue.value ?? "";
          break;
        }
      }
    }
    return retValue;
  }

  protected processOrderAllocations(): void {
    let isMultiAccountBenchmark = false;
    if (this.orderDetails?.allocationData?.length > 0) {
      let state = this.orderDetails?.orderData?.orderState;
      let pendingFwd =
        state === CubiqTS.OrderState.PENDING_FWDS ||
        state === CubiqTS.OrderState.CANCEL_PENDING_FWDS ||
        state === CubiqTS.OrderState.EXPIRY_PENDING_FWDS;

      if (pendingFwd) {
        this.orderDetails.allocationData
          .filter((a) => !a.isSpot)
          .forEach((alloc) => {
            alloc.dealId = alloc.dealRef = null;
          });
      }

      const accountSet: Set<string> = new Set();
      this.orderDetails.allocationData.forEach((allocation) => {
        if (allocation?.accountCode) {
          accountSet.add(allocation.accountCode);
        }
      });
      isMultiAccountBenchmark = accountSet.size > 1;
    }
    this.isMultiAccountBenchmark = isMultiAccountBenchmark;
  }

  protected onBulkOrderLifecycleEvent(event: CubiqTS.BulkOrderLifeCycleEventImpl): void {
    event.events?.forEach((e) => this.onOrderLifecycleEvent(e));
  }

  protected onDealEvent(event: CubiqTS.DealImpl): void {
    let orderId = event.orderId?.toString();

    if (orderId != null && this.mediatedOrderDetails?.orderDetails?.has(orderId)) {
      this.subjectReload?.next(orderId);
    }
  }

  protected onOrderLifecycleEvent(event: CubiqTS.OrderLifeCycleEventImpl): void {
    let orderId = event.orderId?.toString();

    if (orderId != null && this.mediatedOrderDetails?.orderDetails?.has(orderId)) {
      this.subjectReload?.next(orderId);
    }
  }

  protected onBenchmarkLockEvent(event: CubiqTS.BenchmarkLockLifeCycleEventImpl): void {
    if (event.lockType === CubiqTS.LockType.MODIFY_LOCK) {
      let orderDetailMap = this.mediatedOrderDetails?.orderDetails;
      event.orderDatas
        ?.map((o) => o?.orderId?.toString())
        .filter((o) => o != null && orderDetailMap?.has(o))
        .forEach((o) => {
          this.subjectReload?.next(o);
        });
    }
  }

  protected onPauseEvent(event: CubiqTS.PauseLifeCycleEventImpl): void {
    event.orders?.find((o) => {
      let found = this.mediatedOrderDetails?.orderDetails?.has(o.orderId);

      if (found) {
        this.subjectReload.next(o.orderId);
      }

      return found;
    });
  }

  protected onXferEvent(event: CubiqTS.XferEventImpl): void {
    let result = event.orderIds
      ?.filter((o) => o != null)
      .map((o) => o.toString())
      .find((o) => {
        let found = this.mediatedOrderDetails?.orderDetails?.has(o);

        if (found) {
          this.subjectReload.next(o);
        }

        return found;
      });

    if (result == null && event.orderData != null) {
      event.orderData
        .map((o) => o.orderId.toString())
        .find((o) => {
          let found = this.mediatedOrderDetails?.orderDetails?.has(o);

          if (found) {
            this.subjectReload.next(o);
          }

          return found;
        });
    }
  }

  protected closeSubscriptions() {
    if (this.subjectReload != null) {
      this.subjectReload.complete();
      this.subjectReload = null;
    }

    if (this.subscriptionOrderData != null) {
      try {
        this.subscriptionOrderData.unsubscribe();
        this.subscriptionOrderData = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close order lifecycle subscription ${e}`,
          e,
        );
      }
    }

    if (this.subscriptionBulkOrderData != null) {
      try {
        this.subscriptionBulkOrderData.unsubscribe();
        this.subscriptionBulkOrderData = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close bulk order lifecycle subscription ${e}`,
          e,
        );
      }
    }

    if (this.subscriptionDeal != null) {
      try {
        this.subscriptionDeal.unsubscribe();
        this.subscriptionDeal = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close deal event subscription ${e}`,
          e,
        );
      }
    }

    if (this.subcriptionBenchmarkLock != null) {
      try {
        this.subcriptionBenchmarkLock.unsubscribe();
        this.subcriptionBenchmarkLock = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close benchmark lock event subscription ${e}`,
          e,
        );
      }
    }

    if (this.subscriptionPause != null) {
      try {
        this.subscriptionPause.unsubscribe();
        this.subscriptionPause = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close pause event subscription ${e}`,
          e,
        );
      }
    }

    if (this.subscriptionXfer != null) {
      try {
        this.subscriptionXfer.unsubscribe();
        this.subscriptionXfer = null;
      } catch (e) {
        logger.out.debug(
          `${this.constructor.name}: Failed to close xfer event subscription ${e}`,
          e,
        );
      }
    }
  }

  checkEnabledContextItems(enabledItems: BfxBlotterAction[], selectedItems: any): void {
    if (selectedItems != null) {
      selectedItems.forEach((e) => {
        // It's an allocation
        if (e.allocationType != null && e.allocationRef != null && e.dealId === null) {
          let index = enabledItems.indexOf(BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS);
          if (index >= 0) {
            enabledItems.splice(index, 1);
          }
        }
      });
    }
  }

  checkViewTradeDetailItems(items: any, ids: string[]): void {
    items
      .filter((a) => a.allocationType != null && a.allocationRef != null && a.dealId != null)
      .forEach((a) => {
        let index = ids.indexOf(a.allocId);
        if (index >= 0) {
          ids[index] = a.dealId;
        }
      });
  }

  /**
   * Handle a Deal ID event from the allocation grid
   * @param dealId
   */
  public onSelectedAllocationDealChange(dealId: string) {
    this.selectedAllocationDealId = dealId;
    this.processViewTradesButtonState();
  }
}
